/*********************************************************
 * Third Controls
*********************************************************/
import React, { useState, useEffect } from 'react';
import { Grid } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';

import { InputDate, Select, Button, Form } from 'Components';
import { NotificationManager } from 'Components/Notifications';
import { SidePanelFooter } from 'Components/SidePanel';
import ColorSelector from 'Components/ColorSelector'
/*********************************************************
 * Actions
*********************************************************/
import { getVehicleTrailLayerMap } from 'Redux/actions';
import { useRealtimeUnits } from 'Core/hooks';

const initStartingDate = () => {
  let startingMonth = new Date()
  startingMonth.setHours(0, 0, 0);
  return startingMonth;
}

const initEndDate = () => {
  let endMonth = new Date()
  endMonth.setHours(23, 59, 0);
  return endMonth;
}

const VehicleTrail = (props) => {
  const { messages, handleView } = props
  const dispatch = useDispatch()

  const [event, setEvent] = useState({ value: '0', text: 'All' })
  const [unit, setUnit] = useState(null);
  const [startDate, setStartDate] = useState(initStartingDate())
  const [endDate, setEndDate] = useState(initEndDate())
  const [color, setColor] = useState('#fff')

  const loadVehicleTrailsLayer = useSelector(state => state.realtimeMapLayerMapModuleRedux.loadVehicleTrailsLayer);

  const vehicleTrailsLayer = useSelector(state => state.realtimeMapLayerMapModuleRedux.vehicleTrailsLayer);

  const unitsResult = useRealtimeUnits({ trackFields: ['id', 'label', 'show'] });
  const units = React.useMemo(() => {
    let unitList = []
    unitsResult.forEach(unit => {
      if (unit.id !== -1 && unit.show !== 0) {
        unitList.push(unit)
      }
    })
    return unitList
  }, [unitsResult])

  const eventVehicleTrails = [
    { value: '0', text: 'All' },
    { value: 'Drive', text: 'Drive' },
    { value: 'IgnitionOnOff', text: 'Ignition On/Off' },
    { value: 'IgnitionOff', text: 'Ignition Off' },
    { value: 'IgnitionOn', text: 'Ignition On' },
    { value: 'TravelStartStop', text: 'Travel Start/Stop' },
    { value: 'TravelStop', text: 'Travel Stop' },
    { value: 'TravelStart', text: 'Travel Start' }
  ]

  const onChange = (value) => {
    const { start, end } = value;
    setStartDate(start)
    setEndDate(end)
  };

  const handleGetVehicleTrail = () => {
    let initDate = moment(startDate);
    let finalDate = moment(endDate);
    if (!initDate.isValid() || !finalDate.isValid()) {
      NotificationManager.warning(
        messages['realtimemaps_layer_map_invalid_date'],
        messages['realtimemaps_layer_map_vehicle_trail'],
        3000,
        null,
        null,
        'warning',
        null);
      return false
    }
    const rangeDays = finalDate.diff(initDate, 'days');
    if (!unit) {
      NotificationManager.warning(
        messages['realtimemaps_layer_map_validateunit'],
        messages['realtimemaps_layer_map_vehicle_trail'],
        3000,
        null,
        null,
        'warning',
        null);
      return false
    }

    if (rangeDays > 0) {
      NotificationManager.warning(
        messages['realtimemaps_layer_map_validatedate'],
        messages['realtimemaps_layer_map_vehicle_trail'],
        3000,
        null,
        null,
        'warning',
        null);
      return false
    }
    if (color === '#fff') {
      NotificationManager.warning(
        messages['realtimemaps_layer_map_color_validation'],
        messages['realtimemaps_layer_map_vehicle_trail'],
        3000,
        null,
        null,
        'warning',
        null);
      return false
    }
    const paramToGetTrails = {
      unitId: unit.id,
      event: event.value,
      startDate: moment.utc(startDate).format(),
      endDate: moment.utc(endDate).format(),
      color: color ? color : '#fff',
      limit: 100,
      offset: 0,
      messageError: messages['realtimemaps_layer_map_no_data'],
    }
    dispatch(getVehicleTrailLayerMap(paramToGetTrails));
  }

  useEffect(() => {
    setStartDate(initStartingDate());
    setEndDate(initEndDate())
  }, [])

  useEffect(() => {
    if (vehicleTrailsLayer) {
      setColor(null);
      setEvent({ value: '0', text: 'All' });
      setColor('#fff');
      setUnit(null);
    }
  }, [vehicleTrailsLayer])

  return (
    <div>
      <Grid container spacing={1}>
        <Grid item sm={12} className="cnt-date-range-driver">
          <Select
            id="vehicles"
            label={`${messages['realtimemaps_layer_map_unit']}:`}
            value={unit}
            onChange={(event) => setUnit(event)}
            options={units}
            textField="label"
            valueField="id"
            placeholder={messages['vehicleView_select']}
          />
        </Grid>
        <Grid item sm={12}>
          <InputDate
            label={`${messages['realtimemaps_layer_map_date_time']}:`}
            classLabel='input-trail-label'
            value={startDate}
            valueEnd={endDate}
            onChange={onChange}
            id="input-date-range"
            type="rangetimevertical"
            className="vehicletrailsCalendar"
            //classNameDate="report-setup-time-vertical"
            maxDate={new Date()}
            showTimeSelect
            isVertical={false}
            onClose={() => { }}
            required
          />
        </Grid>
        <Grid item sm={12}>
          <Select
            label={`${messages['realtimemaps_layer_map_event']}:`}
            value={event || eventVehicleTrails[0]}
            onChange={(event) => setEvent(event)}
            id="filterevent"
            className="width-select-drivers"
            options={eventVehicleTrails || []}
            textField="text"
            valueField="value"
          />
        </Grid>
        <Grid item sm={12}>
          <div>
            <label className="input-normal-label">{messages['realtimemaps_layer_map_color']}:</label>
            <div style={{ marginTop: 10 }}>
              <ColorSelector
                id="route-color"
                color={color}
                onHandeChange={(event) => setColor(event.color)}
              />
            </div>
          </div>
        </Grid>
        <Grid style={{ marginTop: 20 }} item sm={12}>
          <label className="layer-description" >{messages['realtimemaps_layer_map_vehicle_trail_info']}</label>
        </Grid>
      </Grid>
      <SidePanelFooter>
        <Button
          className='btn-cancel'
          onClick={() => handleView(0)}
        >
          {messages['realtimemaps_layer_map_back']}
        </Button>
        <Button
          className='btn-blue'
          disabled={loadVehicleTrailsLayer}
          onClick={() => handleGetVehicleTrail()}
        >
          {messages['realtimemaps_layer_map_add']}
        </Button>
      </SidePanelFooter>
    </div>
  )
}

export default VehicleTrail;